// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn--contained[data-v-565b4a90] {\n  box-shadow: unset;\n}\n.main-btn[data-v-565b4a90] {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  padding-right: 6px !important;\n}\n.actions-btn[data-v-565b4a90] {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding: 0.2rem !important;\n  margin-left: -3.5px;\n}\n.split-btn[data-v-565b4a90] {\n  display: inline-block;\n}\n.disabled[data-v-565b4a90] {\n  pointer-events: none;\n  opacity: 0.3;\n}", ""]);
// Exports
module.exports = exports;
